import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pay = _resolveComponent("Pay")!
  const _component_setting_card = _resolveComponent("setting-card")!

  return (_ctx.config)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_setting_card, _mergeProps(_ctx.binds, {
          settingBtnTitle: 'Ajouter des crédits',
          dialogBind: _ctx.dialogBind,
          onUpdateProfile: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateProfile())),
          hideMoreVert: true,
          hidePrevious: true
        }), {
          default: _withCtx(() => [
            _createVNode(_component_Pay, {
              companyId: _ctx.companyId,
              inPaymentType: "PAYMENT_CREDIT",
              actions: _ctx.payActions
            }, null, 8, ["companyId", "actions"])
          ]),
          _: 1
        }, 16, ["dialogBind"])
      ]))
    : _createCommentVNode("", true)
}